import { Tabs } from "@shared/ui/tabs";
import { PaymentChannelsSettings } from "./paymentChannels";
import { PaymentModesSettings } from "./paymentModes/paymentModes";

export function PaymentSettings() {
  const tabComponents = {
    channels: {
      label: "Channels",
      shortLabel: "Channels",
     component: <PaymentChannelsSettings />,
    },
    modes: {
      label: "Modes",
      shortLabel: "Modes",
     component: <PaymentModesSettings />,
    }
  };

  const urlMapping = {
    channels: "channels",
    modes: "modes"
  };

  return (
    <div className="space-y-6">
      <Tabs
        defaultValue="channels"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        idPrefix="payment-sub-tab"
        className="w-full"
        level={1}
      />
    </div>
  );
}